// Color utility functions for TradeReady Calendar

/**
 * Add alpha transparency to any color format (hex, rgb, CSS var)
 * @param color - Color value (#RRGGBB, rgb(), var(), etc.)
 * @param alpha - Alpha value (0-1 or 0-100)
 * @returns Color with alpha applied
 */
export function withAlpha(color: string, alpha: number | string): string {
  // Normalize alpha to 0-1 range
  const normalizedAlpha = typeof alpha === 'string' 
    ? parseInt(alpha, 16) / 255  // Handle hex alpha (e.g., "20" → 0.125)
    : alpha > 1 
      ? alpha / 100  // Handle 0-100 range
      : alpha;       // Handle 0-1 range

  // Handle hex colors (#RGB or #RRGGBB)
  if (color.startsWith('#')) {
    const hex = color.replace('#', '');
    const hexAlpha = Math.round(normalizedAlpha * 255).toString(16).padStart(2, '0');
    return `#${hex}${hexAlpha}`;
  }

  // Handle rgb() or rgba()
  if (color.startsWith('rgb')) {
    const rgbMatch = color.match(/rgb\((\d+),\s*(\d+),\s*(\d+)\)/);
    if (rgbMatch) {
      return `rgba(${rgbMatch[1]}, ${rgbMatch[2]}, ${rgbMatch[3]}, ${normalizedAlpha})`;
    }
  }

  // Handle CSS variables or unknown formats - wrap in rgba with fallback
  return `rgba(${color}, ${normalizedAlpha})`;
}
